import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import "./ui/ui.css";

/**
 * Deletion with the message of the API: asks for a confirmation, calls
 * `deleteFunction(seasonId)`, shows the returned message and calls
 * `onSeasonDelete(true)`. `setOpen(null)` is called when the modal closes.
 */
export default function DeleteModal(props) {
  const { children, open = false, setOpen, seasonId, deleteFunction, onSeasonDelete } = props;
  const [deleteMessage, setDeleteMessage] = useState("");
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showModal, setShowModal] = useState(open);
  const [deleting, setDeleting] = useState(false);
  const { t } = useTranslation();

  const close = () => {
    setShowModal(false);
    setDeleteMessage(null);
    if (setOpen) setOpen(null);
  };

  const handleDelete = async () => {
    setDeleting(true);
    try {
      const response = await deleteFunction(seasonId);
      setDeleteMessage(response.message);
      setShowMessageModal(true);
      onSeasonDelete(true);
    } catch (error) {
      console.log(error);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Modal show={showModal} onHide={close} centered dialogClassName="ui-modal ui-confirm">
      <Modal.Body>
        <div className="ui-confirm-body">
          <span
            className="ui-confirm-icon"
            data-danger={showMessageModal ? undefined : true}
            aria-hidden="true"
          >
            <i className={showMessageModal ? "ri-checkbox-circle-line" : "ri-delete-bin-line"}></i>
          </span>
          <div className="ui-confirm-text">
            {showMessageModal ? deleteMessage || t("Deleted") : children}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {showMessageModal ? (
          <button type="button" className="ui-btn" onClick={close}>
            {t("Close")}
          </button>
        ) : (
          <>
            <button type="button" className="ui-btn ui-btn-secondary" onClick={close}>
              {t("Cancel")}
            </button>
            <button
              type="button"
              className="ui-btn ui-btn-danger"
              onClick={handleDelete}
              disabled={deleting}
            >
              {deleting && <span className="ui-spinner" aria-hidden="true" />}
              {t("Delete")}
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
}
